import { AppBar, Toolbar, Typography, Button, Box, Link } from '@mui/material';
import brandLogo from '../assets/images/brand-logo.png';
import { useState } from 'react';
import { IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Toolbar sx={{ justifyContent: 'space-between', py: {xs:2, md: 4} }}>
        <Box display="flex" alignItems="center" width="100%" sx={{ px: {xs: 0, md: 10}, gap: {xs: 10, md: 0}}} justifyContent={"space-between"}>
          <Typography sx={{ flex: '1 1', width: { xs: "250px", md: "350px"} }} variant="h6">
            <Link href="/home"><img width='100%' src={brandLogo} /></Link>
          </Typography>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, flex: '1 1', gap: '20px', justifyContent: 'center' }}>
            <Button sx={{ textTransform: 'none', "&:hover": { background: "#dbf1d2", color: '#000' } }} href="/home">Home</Button>
            <Button sx={{ textTransform: 'none', "&:hover": { background: "#dbf1d2", color: '#000' } }} href="/about">About Us</Button>
            <Button sx={{ textTransform: 'none', "&:hover": { background: "#dbf1d2", color: '#000' } }} href="/products">Our Products</Button>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'block' }, flex: '1 1', textAlign: 'right' }}>
            <Button variant="contained" color="primary" href="/contact">
              Contact Us
            </Button>
          </Box>
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
            <iconify-icon icon="material-symbols:menu-rounded" width="24" height="24"></iconify-icon>
            </IconButton>
          </Box>
        </Box>
      </Toolbar>
      <Drawer anchor="top" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box display="flex" alignItems="center" width="100%" px={5} justifyContent={"space-between"} sx={{ py: 2, boxSizing: 'border-box', gap: 10 }}>
          <Typography sx={{ flex: '1 1', width: "250px" }} variant="h6">
            <Link href="/home"><img width="100%" src={brandLogo} /></Link>
          </Typography>
          <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer(false)}>
            <iconify-icon icon="material-symbols:close" width="24" height="24"></iconify-icon>
          </IconButton>
          </Box>
        <List sx={{ px: 5, boxSizing: 'border-box' }}>
          <ListItem button component="a" href="/home" onClick={toggleDrawer(false)}>
            <ListItemText sx={{ color: 'primary.main' }} primary="Home" />
          </ListItem>
          <ListItem button component="a" href="/about" onClick={toggleDrawer(false)}>
            <ListItemText sx={{ color: 'primary.main' }} primary="About Us" />
          </ListItem>
          <ListItem button component="a" href="/products" onClick={toggleDrawer(false)}>
            <ListItemText sx={{ color: 'primary.main' }} primary="Our Products" />
          </ListItem>
          <ListItem button component="a" href="/contact" onClick={toggleDrawer(false)}>
            <ListItemText sx={{ color: 'primary.main' }} primary="Contact Us" />
          </ListItem>
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Header;
